import MainHeader from '../../../layouts/MainHeader';
import environmentPageData from '../../../data/arabic/environment-page-data-ar';
import BorderLeftBox from '../../../components/boxes/BorderLeftBox';
import SecondaryCard from '../../../components/cards/SecondaryCard';
import Footer from '../../../layouts/Footer';
import TitleBorderLeft from '../../../components/Text/TitleBorderLeft';
import Separator from '../../../components/Separator';
import ChartThree from '../../../components/Charts/ChartThree/ChartThree';
import ChartTwo from '../../../components/Charts/ChartTwo';
import HorizontalChart from '../../../components/Charts/HorizontalChart';
import TitleSection from '../../../components/sections/TitleSection';

const EnvironmentPageAr = () => {
  return (
    <main id="main" className='page'>
    <div className='sticky-view-two'>
      <div className="sticky-container">
        <MainHeader 
          title=""
          image={{
            src : require(`../../../assets/images/wallpaper/${environmentPageData.header.image.name}`),
            alt : environmentPageData.header.image.alt,
          }}
        />
      </div>
      <div className="sticky-container-two" id="mainContent">
        
        <div className="wrapper-small">
          <h1 className="title-center">{environmentPageData.sectionOne.title}</h1>
          <BorderLeftBox 
            title={environmentPageData.sectionOne.borderBox.title}
            subtitle={environmentPageData.sectionOne.borderBox.subtitle}
          />
          <p className="text-paragraph">{environmentPageData.sectionOne.paraghraphOne}</p>
          <p className="text-paragraph">{environmentPageData.sectionOne.paraghraphTwo}</p>
          <p className="text-paragraph">{environmentPageData.sectionOne.paragraphThree}</p>
          <p className="text-paragraph">{environmentPageData.sectionOne.paragraphFour}</p>
        </div>
        <div className='space-50'></div>
        <TitleSection
          title={environmentPageData.centerTitle}
        />
        {
        environmentPageData.sectionTow.map((item, index) => (
          <SecondaryCard
            key={index}
            title={item.title}
            subtitle={item.subtitle}
            icon={{
              name : require(`../../../assets/icons/environment/${item.icon}`),
              alt : ""
            }}
          />
        ))
        }
        <div className="wrapper-small">
          <div className="space-50"></div>
          <p className="text-paragraph">{environmentPageData.subsection.paragraphOne}</p>
          <p className="text-paragraph">{environmentPageData.subsection.paragraphTwo}</p>
          <p className="text-paragraph">{environmentPageData.subsection.paragraphThree}</p>
          <BorderLeftBox 
            title={environmentPageData.subsection.borderLeftBox.title}
            subtitle={environmentPageData.subsection.borderLeftBox.subtitle}
          />
          <div className='space-50'></div>
        </div>
        <div className="space-50"></div>
        <Separator />
        <div className="space-50"></div>
        <div className="wrapper-small">
          <h2 className="text-title">{environmentPageData.sectionSix.title}</h2>
          <TitleBorderLeft>{environmentPageData.sectionSix.titleBorderLeft}</TitleBorderLeft>
          <p className='text-paragraph'>{environmentPageData.sectionSix.paragraphOne}</p>
          <p className='text-paragraph'>{environmentPageData.sectionSix.paragraphTwo}</p>
          <p className='text-paragraph'>{environmentPageData.sectionSix.paragraphThree}</p>
          <p className='text-paragraph'>{environmentPageData.sectionSix.paragraphFour}</p>
          {/* <div className='space-50'></div> */}
          <TitleBorderLeft>{environmentPageData.sectionSix.chartOneSection.title}</TitleBorderLeft>
          <HorizontalChart 
            colGroups={environmentPageData.sectionSix.chartOneSection.chart.data}
            labels={environmentPageData.sectionSix.chartOneSection.chart.labels}
            xAxis={environmentPageData.sectionSix.chartOneSection.chart.xAxis}
          />
          <div className="space-50"></div>
          <div className="space-50"></div>
          <TitleBorderLeft>{environmentPageData.sectionSix.chartSectionTwo.title}</TitleBorderLeft>
          <div className="chart-flex-view">
            <ChartTwo 
              cols={environmentPageData.sectionSix.chartSectionTwo.chartOne.cols}
              maxValue={environmentPageData.sectionSix.chartSectionTwo.chartOne.maxValue}
              xAxis={environmentPageData.sectionSix.chartSectionTwo.chartOne.xAxis}
              title={environmentPageData.sectionSix.chartSectionTwo.chartOne.title}
            />
            <ChartTwo
              cols={environmentPageData.sectionSix.chartSectionTwo.chartTwo.cols}
              maxValue={environmentPageData.sectionSix.chartSectionTwo.chartTwo.maxValue}
              xAxis={environmentPageData.sectionSix.chartSectionTwo.chartTwo.xAxis}
              title={environmentPageData.sectionSix.chartSectionTwo.chartTwo.title}
            />
            <ChartTwo 
              cols={environmentPageData.sectionSix.chartSectionTwo.chartThree.cols}
              maxValue={environmentPageData.sectionSix.chartSectionTwo.chartThree.maxValue}
              xAxis={environmentPageData.sectionSix.chartSectionTwo.chartThree.xAxis}
              title={environmentPageData.sectionSix.chartSectionTwo.chartThree.title}
            />
          </div>
        </div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <div className="wrapper-small">
          <TitleBorderLeft>{environmentPageData.sectionSeven.borderTitleOne}</TitleBorderLeft>
          <div className="space-50"></div>
          {environmentPageData.sectionSeven.subSections.map((item, index) => (
            <>
            <h4 key={index} className="text-title-medium">{item.title}</h4>
            <p key={index} className="text-paragraph">{item.subtitle}</p>
            </>
          ))}
          <TitleBorderLeft>{environmentPageData.sectionSeven.borderTitleTwo}</TitleBorderLeft>
          <p className="text-paragraph">{environmentPageData.sectionSeven.paragraphOne}</p>
        </div>
        <div className="space-50"></div>
        <Separator />
        <div className="space-50"></div>
        <div className="wrapper-small">
          <div className="text-title">{environmentPageData.sectionSevent.title}</div>
          <p className="text-paragraph">{environmentPageData.sectionSevent.paragraphOne}</p>
          <TitleBorderLeft>{environmentPageData.sectionSevent.borderTitle}</TitleBorderLeft>
          {/* <img
            src={require(`../../assets/images/plans/${environmentPageData.sectionSevent.chartImage.image}`)}
            alt={environmentPageData.sectionSevent.chartImage.alt}
            className="chart-image"
          /> */}
          <ChartThree />
        </div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <Footer withBlogs={false} />
      </div>
    </div>
    </main>
)
}

export default EnvironmentPageAr